import React from 'react';
import PropTypes from 'prop-types';
import { warrantyProgress } from 'client/images/inline-svgs/inventory/warranty-progress';

const calculateCircleFillPercent = (currentValue, totalValue) => {
  const percentCurrentValueInTotalValue = currentValue / totalValue;
  if (totalValue === Number.MAX_SAFE_INTEGER) {
    return 1;
  }
  if (percentCurrentValueInTotalValue < 0.05) {
    return 0.95;
  }
  if (percentCurrentValueInTotalValue > 0.95 && percentCurrentValueInTotalValue < 1) {
    return 0.05;
  }

  return Math.max(0, 1 - percentCurrentValueInTotalValue);
};

export function WarrantyPeriodProgress(props) {
  const { totalMiles, currentMiles, totalYears, currentYears, animateWarrantyPeriodProgress } = props;

  return (
    <div>
      {warrantyProgress(
        calculateCircleFillPercent(currentMiles, totalMiles),
        calculateCircleFillPercent(currentYears, totalYears),
        animateWarrantyPeriodProgress
      )}
    </div>
  );
}

WarrantyPeriodProgress.propTypes = {
  totalMiles: PropTypes.number.isRequired,
  currentMiles: PropTypes.number.isRequired,
  totalYears: PropTypes.number.isRequired,
  currentYears: PropTypes.number.isRequired,
  animateWarrantyPeriodProgress: PropTypes.bool.isRequired,
};
